webpackJsonp([15400075347947],{

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SectionTry = __webpack_require__(16);
	
	var _SectionTry2 = _interopRequireDefault(_SectionTry);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { style: { flexGrow: 1 } },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Privacy Policy - DupliDocs' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'pt-5' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Privacy Policy'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'DupliDocs is an application by Duplidocs AB'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Privacy and online safety are important to Basecanvas. '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We collect data about visitors and users (\u201CData\u201D) when they use the platform, the services, and our websites (collectively, \u201CServices\u201D). This Privacy Policy describes how Basecanvas collects, uses and shares Data and what rights you have with respect to that Data.',
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'In this privacy policy, we sometimes refer to \u201CYou\u201D. \u201CYou\u201D may be a visitor to one of our websites or a user of one or more of our Services. This policy does not apply to third-party websites, products, or services even if they link to our Services, and You should consider the privacy practices of those third-parties carefully. If You disagree with the practices described in this policy, You should (a) take the necessary steps to remove cookies from Your computer after leaving our website, and (b) discontinue Your use of our Services. Finally, we have also put together a',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/cookies-policy' },
	            ' Cookie Policy'
	          ),
	          ' that describes in detail how we use cookies and similar technologies.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Data We Collect'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'How Data is collected depends on how our Services are used. Sometimes we get Data directly, such as when You register for a Basecanvas account. Other times we get Data by recording interactions with our Services, for example by using Google Analytics to understand our visitors better. We may also receive Data from third parties, such as our payment provider or identity services.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Personal Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We call Data that identifies, or that could be used to identify, You as an individual as \u201CPersonal Data\u201D. For example, we collect Personal Data when a business registers for a Basecanvas account, an individual answers to a email or survey or the ip address when a browser visits our website. The Personal Data we may collect includes:'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Contact details'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We may collect contact details such as '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          'name, postal address, telephone number, email address. '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Payment details'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'A third party that handles payments for us will receive your payment details. To keep your financial data secure, we do not store sensitive payment details on our servers.',
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Technical data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We collect technical details such as IP address or a device unique identifier. These are sent to us automatically by your browser or device.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Other Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We call Data other than Personal Data \u201COther Data\u201D. We collect Other Data through a variety of sources. One of our sources for Other Data is cookies and other technologies that record Data about the use of our websites, websites that implement our Services, and the use of our Services generally. Other Data that we may collect include:'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Application Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'When you use our Services, we sometimes store application data on your behalf. For example when you add a workout, we store and process that for you to be able to show workout graphs.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Usage information'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We collect usage information about you whenever you interact with our websites and services. This includes which webpages you visit, what you click on, when you perform those actions, what language preference you have, and so on.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Device and browser data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We collect information from the device and application you use to access our services. Device data mainly means operating system version, device type, system and performance information, and browser type. If you are on a mobile device we also collect the UUID for that device.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Log data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Like most websites today, our web servers keep log files that record data each time a device accesses those servers. The log files contain data about the nature of each access, including originating IP addresses, internet service providers, the files viewed on our site (e.g., HTML pages, graphics, etc.), operating system versions, device type and timestamps.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Cookies and other technologies'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We also use third party tracking services that employ cookies and other technologies to collect data about visitors to our websites.',
	          ' '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          'We provide more information on cookies and other technologies in our Cookies Policy. We use certain cookies, as described in our Cookies Policy and here in our Privacy Policy, that you agree to when you use our sites and, in the case of some cookies, for legitimate interests of delivering and optimizing our services (where the cookie delivers essential functionality).'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'How We Use Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Personal Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We and our service providers use Personal Data to: '
	        )
	      ),
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Provide the Services'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Detect and prevent fraud.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Mitigate any harm to You and Basecanvas.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Promote, analyze and improve our products, systems, and tools.',
	            ' '
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Examples of how we may use Personal Data include:'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To verify an identity for compliance purposes.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To evaluate an application to use our Services.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To conduct manual or systematic monitoring for fraud and other harmful activity.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To respond to inquiries, send service notices and provide customer support.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To process a payment through our payment provider, communicate regarding a payment, and provide related customer service.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'For audits, regulatory purposes, and compliance with industry standards.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To develop new products.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To send marketing communications, You can opt-out.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To improve or modify our Services.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'To conduct aggregate analysis and develop business intelligence that enable us to operate, improve, protect, make informed decisions, and report on the performance of our business.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Other Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We may use Other Data for a range of different purposes, provided we comply with applicable law and our contractual commitments.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'How We Share Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Basecanvas does not sell or rent Personal Data to marketers or unaffiliated third parties. We share Your Personal Data with trusted third parties, including:'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Basecanvas Affiliates'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We share Data with entities worldwide that we control, are controlled by us, or are under our common control, to provide our Services. Duplidocs AB is the party responsible for overall management and use of the Data by these affiliated parties.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Aggregated or De-identified Data'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We may disclose or use aggregated or de-identified Other Data for any purpose. For example, we may share aggregated or de-identified Other Data with prospects or partners for business or research purposes, such as telling a prospective Basecanvas customer the average amount of time saved by using our Services.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Authorized Third Parties'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We share data with parties directly authorized by a User to receive Data, such as when a User authorizes a third party application provider to access the User\u2019s Basecanvas account. The use of Data by an authorized third party is subject to the third party\u2019s privacy policy.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Service Providers'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We employ other companies and people to provide services to visitors to our Services and may need to share your information with them to provide information, products or services to you. Examples such as analyzing data or performing statistical analysis, providing marketing assistance, processing credit card payments, supplementing the information you provide us in order to provide you with better service, and providing customer service or support. In all cases where we share your information with such Service Providers, we explicitly require the Service Provider to accept our privacy and customer data handling policies.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Corporate Events'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'If we (or our assets) are acquired by another company, whether by merger, acquisition, bankruptcy or otherwise, that company would receive all data gathered by Basecanvas on our Services. In this event, you will be notified via email and/or a prominent notice on our Services, of any change in ownership, uses of your Personal Data, and choices you may have regarding your Personal Data.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'font-weight-bold' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'Safety, Legal Purposes and Law Enforcement'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We reserve the right to use or disclose your Personal Data if required by law or if we reasonably believe that use or disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or comply with a law, court order, or legal process.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Security'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We use reasonable organizational, technical and administrative measures to protect Personal Data within our organization. Unfortunately, no data transmission or storage system can be guaranteed to be 100% secure. If You have reason to believe that Your interaction with us is no longer secure (for example, if You feel that the security of Your account has been compromised), please contact us immediately.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Retention Period'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We will retain Personal Data for the period necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. Please note that we have a variety of obligations to retain the Data that You provide to us. Please note that even if You close Your Basecanvas Account, we will retain certain Data to meet our obligations. There may also be residual Data that will remain within our databases and other records, which will not be removed.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Advertising'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We partner with a third party ad network to either display advertising on our Web site or to manage our advertising on other sites. Our ad network partner uses cookies and Web beacons to collect information about your activities on this and other Web sites to provide You targeted advertising based upon Your interests. \xA0If you wish to not have this information used for the purpose of serving You targeted ads, You may opt-out by clicking here: http://preferences.truste.com/ (or if located in the European Union, by clicking here: http://www.youronlinechoices.eu/). Please note this does not opt you out of being served advertising. You will continue to receive generic ads.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Your rights'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'To the extent that Basecanvas processing of your Personal Data is subject to the General Data Protection Regulation, Basecanvas relies on its legitimate interests, described above, to process your data. Basecanvas may also process Other Information that constitutes your Personal Data for direct marketing purposes and you have a right to object to Basecanvas use of your Personal Data for this purpose at any time.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'You have the following data protection rights:'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'You can request access, correction, updates or deletion of your Personal Data.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'You can object to processing of your Personal Data, ask us to restrict processing of your Personal Data or request portability of your Personal Data.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'If we have collected and processed your Personal Data with your consent, then you can withdraw your consent at any time. Withdrawing your consent will not affect the lawfulness of any processing we conducted prior to your withdrawal, nor will it affect processing of your Personal Data conducted in reliance on lawful processing grounds other than consent.'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'You have the right to complain to a data protection authority about our collection and use of your Personal Data. Contact details for data protection authorities in the EEA, Switzerland and certain non-European countries (including the US and Canada) are available here.)'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'To exercise any of these rights, please contact us at legal@basecanvas.com or by mail to:'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'We will respond to your request to change, correct, or delete your information within a reasonable timeframe, not more than 30 days, and notify you of the action we have taken.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Use of services by Minors'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'To the extent prohibited by applicable law, Basecanvas does not allow use of our Services and Websites by anyone younger than 16 years old. If you learn that anyone younger than 16 has unlawfully provided us with Personal Data, please contact us and we will takes steps to delete such information.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Cross-Border Data Transfer'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Our services are global and Data (including Personal Data) may be stored and processed in any country where we have operations or where we engage service providers. Basecanvas may transfer your Personal Data to countries other than the one in which you live, including the United States.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Changes To This Privacy Policy'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Basecanvas may change this Privacy Policy from time to time. Laws, regulations and industry standards evolve, which may make those changes necessary, or we may make changes to our business. We will post the changes to this page and encourage you to review our Privacy Policy to stay informed. If we make changes that materially alter your privacy rights, Basecanvas will inform You via email or through the Services. If you disagree with the changes to this Privacy Policy, you should deactivate your Services account.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Data Protection Representative'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'If You are located in the European Economic Area ("EEA"), Duplidocs AB (Sweden, 559241-4675) is the data controller of your personal information. This Data Protection Officer can be contacted at legal-eea@basecanvas.com.',
	          ' '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('br', null),
	          'If You are located outside the European Economic Area ("EEA"), Duplidocs AB is the data controller of your personal information. This Data Protection Representative can be contacted at legal@basecanvas.com.',
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Contacting Basecanvas'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'If You have any questions about this Privacy Policy, please contact us at legal@basecanvas.com or at:'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement('span', null)
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-686dad9f4ace811ba0cf.js